export const commonOptions = [
    {
        id: 1,
        value: "Option 1",
        disabled: false,
        danger: false,
    },
    {
        id: 2,
        value: "Option 2",
        disabled: false,
        danger: false,
    },
    {
        id: 3,
        value: "Option danger",
        disabled: false,
        danger: true,
    },
    {
        id: 4,
        value: "Option disabled",
        disabled: true,
        danger: false,
    },
];
export const commonOptions2 = [
    {
        id: 11,
        value: "Option 1 option 1 to see",
        disabled: false,
        danger: false,
    },
    {
        id: 12,
        value: "Option 2",
        disabled: false,
        danger: false,
        child: [
            {
                id: 121,
                value: "Sub Option 2",
                disabled: false,
                danger: false,
            },
            {
                id: 131,
                value: " Sub Option danger",
                disabled: false,
                danger: true,
            },
        ],
    },

    {
        id: 13,
        value: "Option danger",
        disabled: false,
        danger: true,
    },
    {
        id: 14,
        value: "Option disabled",
        disabled: true,
        danger: false,
    },
];


export const multiOptions = [
    {
        id: 111,
        value: "Option 1 option 1 to see",
        disabled: false,
        danger: false,
    },
    {
        id: 122,
        value: "Option 2",
        disabled: false,
        danger: false,
        child: [
            {
                id: 1211,
                value: "Sub Option 2",
                disabled: false,
                danger: false,
            },
            {
                id: 1312,
                value: " Sub Option danger",
                disabled: false,
                danger: true,
            },
        ],
    },

    {
        id: 133,
        value: "Option danger",
        disabled: false,
        danger: true,
    },
    {
        id: 144,
        value: "Option disabled",
        disabled: true,
        danger: false,
    },
];


export const commonOptions3 = [
    {
        id: 64731,
        value: "Option 1",
    },
    {
        id: 2890,
        value: "Option 2",
    },
    {
        id: 2453,
        value: "Option 3",
    },
    {
        id: 34354,
        value: "Option 4",
    },
];
export const commonOptions4 = [
    {
        id: 1252,
        value: "Option 1",
    },
    {
        id: 2452,
        value: "Option 2",
    },
    {
        id: 3422,
        value: "Option 3",
    },
    {
        id: 4852,
        value: "Option 4",
    },
];
export const commonOptions5 = [
    {
        id: 349981,
        value: "Option 1",
    },
    {
        id: 38942,
        value: "Option 2",
    },
    {
        id: 3483,
        value: "Option 3",
    },
    {
        id: 47834,
        value: "Option 4",
    },
];
export const commonOptions6 = [
    {
        id: 2361,
        value: "Option 1",
    },
    {
        id: 25632,
        value: "Option 2",
    },
    {
        id: 23433,
        value: "Option 3",
    },
    {
        id: 22334,
        value: "Option 4",
    },
];

export const commonOptions7 = [
    {
        id: 3232431,
        value: "Option 1",
    },
    {
        id: 2332,
        value: "Option 2",
    },
    {
        id: 233367,
        value: "Option 3",
    },
    {
        id: 23434,
        value: "Option 4",
    },
];
export const commonOptions8 = [
    {
        id: 931,
        value: "Option 1",
    },
    {
        id: 932,
        value: "Option 2",
    },
    {
        id: 923,
        value: "Option 3",
    },
    {
        id: 934,
        value: "Option 4",
    },
];

export const commonOptions9 = [
    {
        id: 23281,
        value: "Option 1",
    },
    {
        id: 2323982,
        value: "Option 2",
    },
    {
        id: 232383,
        value: "Option 3",
    },
    {
        id: 3984,
        value: "Option 4",
    },
];
